export default __webpack_public_path__ + "static/media/firefox.3816d159.webp";